/**
 * @module byo-bundle/drawer
 * Opens and closes a slot's native <dialog>, locking body scroll with its own class so other overlays keep theirs.
 */

import { CLASSES } from './constants.js';

export function openDrawer(dialog: HTMLDialogElement) {
  dialog.showModal();
  document.body.classList.add(CLASSES.bodyLock);
}

export function closeDrawer(dialog: HTMLDialogElement) {
  dialog.close();
}

/** Bound to the dialog's `close` event so Esc and backdrop clicks also release the lock. */
export function releaseScroll() {
  document.body.classList.remove(CLASSES.bodyLock);
}
